export const priceValueType = { value: 'Price', name: 'price', fieldName: 'price' };
export const marketCapValueType = { value: 'Market cap', name: 'market_cap', fieldName: 'marketCap' };
export const marketVol24ValueType = { value: 'Volume', name: 'market_vol_24h', fieldName: 'marketVol24h' };

export const valueTypes = [
  priceValueType,
  marketCapValueType,
  marketVol24ValueType,
];



// WEBPACK FOOTER //
// ./src/models/AlertsValueTypes.js